export default {
  orgMonitoring: {},
  orgMonitorings: [],
}
